<script setup lang="ts">
import { computed } from 'vue'
import { dateLabel, ntrpRange, statusText } from '../services/format'
import DsIcon from './DsIcon.vue'

const props = defineProps<{ activity: any }>()
const id = computed(() => String(props.activity?.id || props.activity?.activityId || ''))
const title = computed(() => String(props.activity?.title || '一起打网球'))
const enrolled = computed(() => Number(props.activity?.enrolledCount || props.activity?.currentParticipants || 0))
const capacity = computed(() => Number(props.activity?.capacity || props.activity?.totalSlots || 0))
</script>

<template>
  <RouterLink class="activity-card" :to="`/activities/${encodeURIComponent(id)}`">
    <div class="activity-date"><b>{{ String(activity.date || '').slice(5).replace('-', '/') || '待定' }}</b><span>{{ statusText(activity.status, activity.date, activity.startTime, activity.endTime) }}</span></div>
    <div class="activity-content">
      <div class="card-title-row"><h3>{{ title }}</h3><span class="level-badge">{{ ntrpRange(activity.levelMin, activity.levelMax) }}</span></div>
      <p><DsIcon name="event" :size="16" />{{ dateLabel(activity.date, activity.startTime, activity.endTime) }}</p>
      <p><DsIcon name="place" :size="16" />{{ activity.venueName || activity.customVenueName || activity.address || '地点待定' }}</p>
      <div class="activity-footer"><span><DsIcon name="groups" :size="16" />{{ enrolled }}/{{ capacity || '—' }} 人</span><strong>{{ Number(activity.price || 0) > 0 ? `¥${activity.price}` : '免费' }}</strong></div>
    </div>
  </RouterLink>
</template>
